// extracted by mini-css-extract-plugin
export default {"payment":"borrowingCapacityResultPay_payment__Go6Ib","label":"borrowingCapacityResultPay_label__fCw72"};